import {
  Button,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useRef, useState } from "react";
import MultiSelectAutoComplete, { ChildComponentRef } from "shared-component/autocomplete-checkbox-multiple";
import { AGGREGATIONDATALIST, AGGREGATIONVALUEEDISCRETEQUARTILEEXCLUDELIST } from "utility/constants";
import { autoCompleteSelectOptionsFormat, selectedListValues } from "utility/helper";
import { listItemProp } from "utility/types";

export interface HeatMapProps {
  signalList: string[];
  updateHeatMapFilter: (value: any) => void;
  setAggregationValue: (value: string) => void;
}

const HeatMapFilterComponent = (props: HeatMapProps) => {
  const [signal, setSignal] = useState<string[]>([]);
  const [groupBy, setGroupBy] = useState<string>();
  const [aggregation, setAggregation] = useState<string>('');
  const childRef = useRef<ChildComponentRef>({ clearSelection: () => { } });
  
  const handleSignalSelection = (selectedList: listItemProp[]) => {
    const value: string[] = selectedListValues(selectedList);
    setSignal(
      value
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        justifyContent: "space-evenly",
      }}
    >
      <FormControl style={{ width: "100%" }}>
        <MultiSelectAutoComplete
                    items={autoCompleteSelectOptionsFormat(props?.signalList)}
                    label="Select / Search Signals"
                    selectAllLabel="Select All"
                    onChange={(value: listItemProp[]) => {
                      // if (value?.length > 0) handleSignalSelection(value)
                      handleSignalSelection(value)
                    }}
                    ref={childRef}
                  />
      </FormControl>
      <FormControl style={{ width: "100%" }}>
        <InputLabel htmlFor="grouped-native-select">Group By</InputLabel>
        <Select
          id="modelSelect"
          value={groupBy}
          onChange={(event) => {
            const {
              target: { value },
            } = event;
            setGroupBy(value);
          }}
          input={<OutlinedInput label="Group By" />}
        >
          {AGGREGATIONDATALIST?.map(
            (item: any, index: number) => (
              <MenuItem key={index} value={item.value}>
                <ListItemText style={{ textTransform: 'capitalize' }} primary={item.label} />
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>
      <FormControl style={{ width: "100%" }}>
        <InputLabel htmlFor="grouped-native-select">Aggregation</InputLabel>
        <Select
          id="modelSelect"
          value={aggregation}
          onChange={(event) => {
            const {
              target: { value },
            } = event;
            setAggregation(value);
          }}
          input={<OutlinedInput label="Aggregation" />}
        >
          {AGGREGATIONVALUEEDISCRETEQUARTILEEXCLUDELIST.map(
            (item: any, index: number) => (
              <MenuItem key={index} value={item.value}>
                <ListItemText style={{ textTransform: 'capitalize' }} primary={item.label} />
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: '8px',
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            props?.updateHeatMapFilter({signal: signal, groupBy: groupBy, aggregation: aggregation})
            props?.setAggregationValue(aggregation)
          }}
          disabled={ signal?.length === 0 || aggregation === ''}
        >
          APPLY
        </Button>
      </div>
    </div>
  );
};

export default HeatMapFilterComponent;
